<div class="container">
    <div class="thanks">
        <img src="/assets/img/thanks.png" alt="thank you">
        <p>{{ "thank.content" | translate }}</p>
        <button (click)="goToTop()" pButton class="p-button-warning btn-confirm btn-custom">
            {{ "preview.top" | translate }}
          </button>
    </div>
</div>
  